// extracted by mini-css-extract-plugin
export default {"paymentOptionsWrapper":"styles_paymentOptionsWrapper__3Up8l","logos":"styles_logos__WhaR9","otherPaymentButton":"styles_otherPaymentButton__EJjS1"};